import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcCollaboration, FcEditImage } from "react-icons/fc";
import { graphicsInfo } from "../../../SchemaInfo/info";
import { useEffect } from "react";

const AddGraphics = () => {
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState([]);
  const [proofPreview, setProofPreview] = useState([]);
  const [socialMedia, setSocialMedia] = useState([]);

  const imageInputRef = useRef(null);
  const proofInputRef = useRef(null);

  const navigate = useNavigate();

  const handelSubmit = (values) => {
    setLoading(true);

    let formData = new FormData();

    Object.keys(values).forEach((key) => {
      if (
        key !== "uploadImages" &&
        key !== "platforms" &&
        key !== "markAsPublished" &&
        key !== "rawImage"
      ) {
        formData.append(key, values[key]);
      }
    });

    if (values.rawImage) {
      formData.append("rawImage", values.rawImage);
    }

    values.uploadImages.forEach((file) => {
      formData.append("images", file);
    });

    values.platforms.forEach((p) => {
      formData.append("platforms[]", p);
    });

    values.markAsPublished.forEach((file) => {
      formData.append("proofs", file);
    });

    performRequest("POST", `/graphics/create-graphics`, formData, {
      "Content-Type": "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Graphics created successfully!");
          navigate("/all-graphics");
        } else {
          Toast("error", "Something went wrong");
        }
      })
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  };

   useEffect(() => {
      setLoading(true);
      performRequest("GET", `/podcast/social-media-users`)
        .then((res) => {
          if (res.status === 200) {
            setSocialMedia(res.data);
            // console.log(buyersManagementInfo);
          } else {
            Toast("error", "Error while getting social media!");
          }
          setLoading(false);
        })
        .catch((err) => {
          // Toast("error", "Server Error!");
          // console.error(err);
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }, []);


  if (loading) return <LoadingPage />;

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header">
            <h2 className="page-title">
              <FcEditImage /> Create Graphics Post
            </h2>
            <StepRoutes />
          </div>

          <div className="card my-4">
            <div className="card-header">
              <h3>Create New Graphics</h3>
            </div>

            <Formik initialValues={graphicsInfo} onSubmit={handelSubmit}>
              {(props) => (
                <Form>
                  <div className="card-body">
                    {/* Branding */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Branding</label>
                      <div className="col">
                        <CustomSelect
                          name="postBranding"
                          type="text"
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option>Kryzen Biotech</option>
                          <option>Sudhir Devkar</option>
                          <option>Hydroponic Masterclass</option>
                          <option>Eat Pure Green</option>
                        </CustomSelect>
                        {props.touched.postBranding &&
                          props.errors.postBranding && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.postBranding}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* Headline */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Post Headline
                      </label>
                      <div className="col">
                        <CustomInput name="postHeadline" />
                        {props.touched.postHeadline &&
                          props.errors.postHeadline && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.postHeadline}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* Subheading */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Post Subheading
                      </label>
                      <div className="col">
                        <CustomInput name="postSubheading" />
                        {props.touched.postSubheading &&
                          props.errors.postSubheading && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.postSubheading}{" "}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                         Editor Name
                      </label>
                      <div className="w-100 col">
            
                        <CustomSelect name="graphicsEditor">
                          <option value="">Select</option>
                          {socialMedia?.map((item, index) => {
                            return (
                              <option key={index} value={item?.userName}>
                                {item?.userName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Deadline</label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="taskdedline"
                        ></CustomInput>
                      </div>
                    </div>

                    {/* CTA */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Post CTA</label>
                      <div className="col">
                        <CustomInput name="postCta" />
                        {props.touched.postCta &&
                          props.errors.postCta && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.postCta}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* CTA Sub */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">CTA Subheading</label>
                      <div className="col">
                        <CustomInput name="ctaSubheading" />
                        {props.touched.ctaSubheading &&
                          props.errors.ctaSubheading && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.ctaSubheading}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* Raw Image */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Raw Image</label>
                      <div className="col">
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) =>
                            props.setFieldValue("rawImage", e.target.files[0])
                          }
                        />
                        {props.touched.rawImage &&
                          props.errors.rawImage && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.rawImage}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* Title */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Post Title</label>
                      <div className="col">
                        <CustomInput name="postTitle" />
                        {props.touched.postTitle &&
                          props.errors.postTitle && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.postTitle}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* Description */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Description</label>
                      <div className="col">
                        <CustomTextArea name="postDescription" />
                        {props.touched.postDescription &&
                          props.errors.postDescription && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.postDescription}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* Post Type */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Post Type</label>
                      <div className="col">
                        <CustomSelect name="postType">
                          <option value="">Select</option>
                          <option>Job Post</option>
                          <option>Product Promotion</option>
                          <option>Carousel</option>
                          <option>BTS</option>
                          <option>Update</option>
                          <option>Review</option>
                        </CustomSelect>
                        {props.touched.postType &&
                          props.errors.postType && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.postType}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* Platforms */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Platforms</label>
                      <div className="col">
                        {[
                          "LinkedIn",
                          "YouTube",
                          "Instagram",
                          "Facebook",
                          "Google Photos",
                        ].map((p) => (
                          <label key={p} className="me-3">
                            <input
                              type="checkbox"
                              style={{width:"18px", height:"18px"}}
                              checked={props.values.platforms.includes(p)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  props.setFieldValue("platforms", [
                                    ...props.values.platforms,
                                    p,
                                  ]);
                                } else {
                                  props.setFieldValue(
                                    "platforms",
                                    props.values.platforms.filter(
                                      (item) => item !== p
                                    )
                                  );
                                }
                              }}
                            />{" "}
                            {p}
                          </label>
                        ))}
                      </div>
                      {props.touched.platforms &&
                          props.errors.platforms && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.platforms}{" "}
                            </p>
                          )}
                    </div>

                    {/* 🔥 Upload Images */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Upload Images</label>
                      <div className="col">
                        <input
                          type="file"
                          multiple
                          ref={imageInputRef}
                          className="form-control"
                          onChange={(e) => {
                            const files = Array.from(e.target.files);

                            props.setFieldValue("uploadImages", [
                              ...props.values.uploadImages,
                              ...files,
                            ]);

                            const preview = files.map((file) => ({
                              file,
                              url: URL.createObjectURL(file),
                            }));

                            setImagePreview((prev) => [...prev, ...preview]);

                            e.target.value = "";
                          }}
                        />

                        <div className="d-flex flex-wrap mt-3">
                          {imagePreview.map((img, index) => (
                            <div
                              key={index}
                              style={{ marginRight: 10, position: "relative" }}
                            >
                              <img
                                src={img.url}
                                width="100"
                                height="100"
                                style={{ objectFit: "cover" }}
                              />
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                }}
                                onClick={() => {
                                  const updated = [
                                    ...props.values.uploadImages,
                                  ];
                                  updated.splice(index, 1);

                                  const preview = [...imagePreview];
                                  preview.splice(index, 1);

                                  props.setFieldValue("uploadImages", updated);
                                  setImagePreview(preview);

                                  if (updated.length === 0) {
                                    imageInputRef.current.value = "";
                                  }
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* 🔥 Proof Upload */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Mark as Published (Upload proof)</label>
                      <div className="col">
                        <input
                          type="file"
                          multiple
                          ref={proofInputRef}
                          className="form-control"
                          onChange={(e) => {
                            const files = Array.from(e.target.files);

                            props.setFieldValue("markAsPublished", [
                              ...props.values.markAsPublished,
                              ...files,
                            ]);

                            const preview = files.map((file) => ({
                              file,
                              url: URL.createObjectURL(file),
                            }));

                            setProofPreview((prev) => [...prev, ...preview]);

                            e.target.value = "";
                          }}
                        />

                        <div className="d-flex flex-wrap mt-3">
                          {proofPreview.map((img, index) => (
                            <div
                              key={index}
                              style={{ marginRight: 10, position: "relative" }}
                            >
                              <img src={img.url} width="100" height="100" />
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                }}
                                onClick={() => {
                                  const updated = [
                                    ...props.values.markAsPublished,
                                  ];
                                  updated.splice(index, 1);

                                  const preview = [...proofPreview];
                                  preview.splice(index, 1);

                                  props.setFieldValue(
                                    "markAsPublished",
                                    updated
                                  );
                                  setProofPreview(preview);

                                  if (updated.length === 0) {
                                    proofInputRef.current.value = "";
                                  }
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer text-end">
                    <FormSubmitButton buttonText="Create Graphics" />
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AddGraphics;
